

export const extractelement = (JsonList) => {
	let riskprops = JsonList

    let risk_info_temp = {}
    let control_info_temp = {}
    let action_info_temp = {}
    let owner_info_temp = {}
    let kri_threshold_info_temp = {}
    let risk_tolerance_info_temp = {}


    let owners = riskprops.owners
    let leader = owners.filter(item => item.risk_lead != null)
    let supportor = owners.filter(item => item.risk_lead == null)


    // risk info not need to separate into element array because this is only 1 risk for the same riskname

    risk_info_temp['RiskDescription'] = riskprops.risk_description
    risk_info_temp['RiskAppetiteStatement'] = riskprops.risk_appetite_statements
    risk_info_temp['Strategic'] = riskprops.strategic
    risk_info_temp['Operational'] = riskprops.operational
    risk_info_temp['Compliance'] = riskprops.compliance
    risk_info_temp['Financial'] = riskprops.financial
    risk_info_temp['Technology'] = riskprops.technology
    risk_info_temp['NETS Entity'] = riskprops.NETS
    risk_info_temp['BCS Entity'] = riskprops.BCS
    risk_info_temp['BCSIS Entity'] = riskprops.BCSIS
    risk_info_temp['No'] = riskprops.no_appetite
    risk_info_temp['V. Low'] = riskprops.very_low_appetite
    risk_info_temp['Low'] = riskprops.low_appetite
    risk_info_temp['Medium'] = riskprops.medium_appetite
    risk_info_temp['High'] = riskprops.high_appetite
    risk_info_temp['driver'] = riskprops.risk_driver
    risk_info_temp['consequence'] = riskprops.risk_consequence
    risk_info_temp['GrossLike'] = riskprops.gross_likelhood
    risk_info_temp['GrossImpact'] = riskprops.gross_impact
    risk_info_temp['ResidualLike'] = riskprops.residual_likelhood
    risk_info_temp['ResidualImpact'] = riskprops.residual_impact
    risk_info_temp['TargetLike'] = riskprops.target_likelhood
    risk_info_temp['TargetImpact'] = riskprops.target_impact
    risk_info_temp['GrossRating'] = riskprops.gross_rating
    risk_info_temp['ResidualRating'] = riskprops.residual_rating
    risk_info_temp['TargetRating'] = riskprops.target_rating

    owner_info_temp['Risk Owners'] = leader
    owner_info_temp['Supported by'] = supportor


    // control info
    let control = riskprops.controls
    let ControlNo = []
    let ControlDescription = []
    let ControlOwner = []
    let ControlFrequency = []
    let ControlNETS = []
    let ControlBCS = []
    let ControlBCSIS = []
    let ControlStrength = []
    let ControlRCSA = []
    let ControlIA = []
    let ControlOthers = []
    for (let itemindex in control) {
        let item = control[itemindex]
        ControlNo.push(item.control_no)
        ControlDescription.push(item.summary_of_controls)
        ControlOwner.push(item.control_owner)
        ControlFrequency.push(item.frequency)
        ControlNETS.push(item.NETS)
        ControlBCS.push(item.BCS)
        ControlBCSIS.push(item.BCSIS)
        ControlStrength.push(item.control_strength)
        ControlRCSA.push(item.RCSA)
        ControlIA.push(item.IA)
        ControlOthers.push(item.others)
    }

    control_info_temp.control = control
    control_info_temp.ControlNo = ControlNo
    control_info_temp.ControlDescription = ControlDescription
    control_info_temp.ControlOwner = ControlOwner
    control_info_temp.ControlFrequency = ControlFrequency
    control_info_temp.ControlNETS = ControlNETS
    control_info_temp.ControlBCS = ControlBCS
    control_info_temp.ControlBCSIS = ControlBCSIS
    control_info_temp.ControlStrength = ControlStrength
    control_info_temp.ControlRCSA = ControlRCSA
    control_info_temp.ControlIA = ControlIA
    control_info_temp.ControlOthers = ControlOthers

    let actions = riskprops.actions
    let ActionPlanNo = []
    let ActionPlanDescription = []
    let ActionOwner = []
    let ActionType = []
    let ControlRef = []
    let implementationStatus = []
    let actionTimeline = []
    for (let itemindex in actions) {
        let item = actions[itemindex]
        ActionPlanNo.push(item.action_plans_no)
        ActionPlanDescription.push(item.summary_of_action_plans)
        ActionOwner.push(item.action_plans_owner)
        ActionType.push(item.action_type)
        ControlRef.push(item.control_reference)
        implementationStatus.push(item.implementation_status)
        actionTimeline.push(item.timeline)
    }
	action_info_temp.actions = actions
    action_info_temp.ActionPlanNo = ActionPlanNo
    action_info_temp.ActionPlanDescription = ActionPlanDescription
    action_info_temp.ActionOwner = ActionOwner
    action_info_temp.ActionType = ActionType
    action_info_temp.ControlRef = ControlRef
    action_info_temp.implementationStatus = implementationStatus
    action_info_temp.actionTimeline = actionTimeline

    let kris = riskprops.kri
    let kriNo = []
    let kriDescription = []
    let kriOwner=[]
    let kriFrequency =[]
    let kriLeftBound =[]
    let kriRightBound = []
    for (let itemindex in kris) {
        let item = kris[itemindex]
        kriNo.push(item.kri_id)
        kriDescription.push(item.kri_description)
        kriOwner.push(item.kri_owner)
        kriFrequency.push(item.frequency)
        kriLeftBound.push(item.kri_left_bound)
        kriRightBound.push(item.kri_right_bound)
    }
	kri_threshold_info_temp.kris = kris
    kri_threshold_info_temp.kriNo = kriNo
    kri_threshold_info_temp.kriDescription = kriDescription
    kri_threshold_info_temp.kriOwner = kriOwner
    kri_threshold_info_temp.kriFrequency = kriFrequency
    kri_threshold_info_temp.kriLeftBound = kriLeftBound
    kri_threshold_info_temp.kriRightBound = kriRightBound

    let riskTolerances = riskprops.risk_tolerance
    let riskToleranceNo = []
    let riskToleranceDescription = []
    let riskToleranceOwner=[]
    let riskTolerancevalue = []

    for (let itemindex in riskTolerances) {
        let item = riskTolerances[itemindex]
        riskToleranceNo.push(item.risk_tolerance_id)
        riskToleranceDescription.push(item.risk_tolerance_description)
        riskToleranceOwner.push(item.risk_tolerance_owner)
        riskTolerancevalue.push(item.risk_tolerance_tolerance)
    }
	risk_tolerance_info_temp.riskTolerances = riskTolerances
    risk_tolerance_info_temp.riskToleranceNo = riskToleranceNo
    risk_tolerance_info_temp.riskToleranceDescription = riskToleranceDescription
    risk_tolerance_info_temp.riskToleranceOwner = riskToleranceOwner
    risk_tolerance_info_temp.riskTolerancevalue = riskTolerancevalue

    let returnData = {}
    returnData.risk_info_temp = risk_info_temp
    returnData.control_info_temp = control_info_temp
    returnData.action_info_temp = action_info_temp
    returnData.owner_info_temp = owner_info_temp
    returnData.kri_threshold_info_temp = kri_threshold_info_temp
    returnData.risk_tolerance_info_temp = risk_tolerance_info_temp


    return returnData

}


// WEBPACK FOOTER //
// ./src/components/Risks/helper/Datahelper.js